import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ETextbook = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M33.347 2.58A6.485 6.485 0 0 0 28.512.42H10.114a6.501 6.501 0 0 0-6.495 6.494v27.18c0 1.301.502 2.483 1.313 3.39l.108.108c.06.06.131.12.19.19l5.23 5.122a5.065 5.065 0 0 0 3.63 1.516h21.203a5.09 5.09 0 0 0 5.086-5.085V12.142c0-1.743-.692-3.39-1.946-4.62l-5.086-4.941ZM5.422 6.903a4.713 4.713 0 0 1 4.704-4.703h7.498v7.759c0 .358.214.692.549.823.334.143.716.06.979-.19l3.557-3.558 3.558 3.557a.916.916 0 0 0 .633.263.9.9 0 0 0 .896-.895v-7.76h.728a4.713 4.713 0 0 1 4.704 4.704v27.18c0 1.815-1.48 3.307-3.295 3.307H8.717a3.264 3.264 0 0 1-2.412-1.074 3.255 3.255 0 0 1-.883-2.233V6.902Zm33.166 32.433a3.301 3.301 0 0 1-3.295 3.294H14.09a3.28 3.28 0 0 1-2.364-1.002c-.024-.024-1.23-1.206-2.508-2.447h20.703a5.092 5.092 0 0 0 5.086-5.098V6.902c0-.072-.012-.155-.012-.227L37.179 8.8a4.66 4.66 0 0 1 1.41 3.342v27.193Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M18.985 29.642c2.137 0 4.047-.812 5.67-2.411a.9.9 0 0 0 .012-1.266.901.901 0 0 0-1.265-.012c-1.301 1.278-2.734 1.898-4.405 1.898a4.41 4.41 0 0 1-4.406-4.404v-.61h9.694c.49 0 .896-.405.896-.895v-.907a6.206 6.206 0 0 0-6.196-6.195 6.206 6.206 0 0 0-6.197 6.195v2.412a6.206 6.206 0 0 0 6.197 6.195Zm-4.406-8.607a4.41 4.41 0 0 1 4.406-4.405 4.402 4.402 0 0 1 4.405 4.405h-8.81Z"
  })));
});
ETextbook.displayName = 'ETextbook';
ETextbook.defaultProps = {
  'aria-label': 'ETextbook'
};
export default ETextbook;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/ETextbook.js
// module id = 3965
// module chunks = 11